import Reflux from 'reflux';
import EventDocData from 'shared/data/EventDoc';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

let async = { asyncResult: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);

let EventDocListActions = Reflux.createActions({
  populate: {},
  loadPage: async,
  loadArchivedPage: async,
  softDelete: asyncReadOnlyCfg,
  archive: asyncReadOnlyCfg,
  restoreArchived: asyncReadOnlyCfg,
  downloadDocIntoWindow: { sync: true },
  downloadDoc: async,
  toggleDocEdit: {},
  cancelDocEdit: {},
  saveDocEditChanges: {},
  saveDocChangesPersistent: {},
  saveDocChangesTransient: {},
  docNameInputChange: {},
});

EventDocListActions.loadPage.listenAndPromise(EventDocData.getByEventId);

EventDocListActions.loadArchivedPage.listenAndPromise(
  (teamId, eventId, pageNumber, pageSize) =>
    EventDocData.getByEventId(
      teamId,
      eventId,
      pageNumber,
      pageSize,
      true,
      false,
    ),
);

EventDocListActions.softDelete.listenAndPromise(EventDocData.softDelete);
EventDocListActions.archive.listenAndPromise(EventDocData.archive);
EventDocListActions.restoreArchived.listenAndPromise(
  EventDocData.restoreArchived,
);

EventDocListActions.downloadDocIntoWindow.listen(
  (teamId, eventId, eventDocId, asAttachment) => {
    let $window = window;
    if (!asAttachment) $window = window.open('');

    EventDocListActions.downloadDoc(
      teamId,
      eventId,
      eventDocId,
      $window,
      asAttachment,
    );
  },
);

EventDocListActions.downloadDoc.listenAndPromise(
  (teamId, eventId, eventDocId, $window, attachment) => {
    return EventDocData.getSignedUrl(
      teamId,
      eventId,
      eventDocId,
      attachment,
    ).then(({ url }) => ($window.location = url));
  },
);

export default EventDocListActions;
